<template>
    <div>
        <div class="itinerary-item">
            <p class="itinerary-item__time">
                {{ itemTime }}
            </p>

            <p class="itinerary-item__title">
                {{ item.title }}
            </p>

            <p class="itinerary-item__body">{{ item.body }}</p>

            <img v-if="item.image" v-bind:src="item.image" class="itinerary-item__image mt-3"/>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT, LOCAL_DATE_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";

    export default {
        props: ['item'],

        computed: {
            itemTime() {
                return moment(this.item.time, SERVER_TIME_FORMAT).format(LOCAL_TIME_FORMAT);
            }
        }
    }
</script>

<style scoped lang="scss">
    .itinerary-item {
        padding-bottom: 1rem;

        p {
            margin: 0;
            line-height: 1;
        }

        &__time {
            @include font-h2;
        }

        &__title{
            @include font-h3;
        }

        &__body {
            font-size: 16px;
            margin-bottom: 5px;
            white-space: pre-wrap;
        }

    }
</style>